import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import PropTypes from 'prop-types';
import UserManual from 'components/UserManual';
import SupportDocs from 'components/SupportDocs';
import { LoaderButton, ContinueLabel } from 'ctia-ui';
import StaffDecision from 'containers/request/Initial/StaffDecision';
import { hasDocsForUpload } from 'helpers/Uploads';
import { saveRequest } from 'actions/request';
import { submitWizardStep } from 'actions/wizard';
import { deleteUsersManual } from 'actions/uploads';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { hasManualFile, hasUploadedManual } from 'helpers/RequestHelper';

class Documents extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = { isManualTab: true };
  }

  handleSelect(key) {
    this.setState({ isManualTab: key === 1 });
  }

  onSaveClick = () => {
    const { request, deleteUsersManual } = this.props;

    // check if user set brand new file for users manual
    if (hasManualFile(request) && hasUploadedManual(request)) {
      deleteUsersManual(request.model.id).then(this.uploadManualCallback);
    } else {
      this.uploadManualCallback();
    }
  };

  uploadManualCallback = () => {
    const { startPreloader, finishPreloader, saveRequest } = this.props;

    startPreloader();
    saveRequest(finishPreloader);
  };

  render() {
    const { show, request, canSubmit, wizard, user } = this.props;

    if (!show) return null;

    const hasDocsToUpload = hasDocsForUpload(request.supportDocs);

    const tabStyle = {
      paddingTop: 25
    };

    return (
      <div>
        <StaffDecision isActiveTab={this.state.isManualTab} />
        <Tabs
          defaultActiveKey={1}
          id="documents-tabs"
          onSelect={this.handleSelect}
        >
          <Tab eventKey={1} title="Product Description" style={tabStyle}>
            <UserManual canSubmit={canSubmit} />
          </Tab>
          <Tab
            eventKey={2}
            title="Optional Supporting Documentation"
            style={tabStyle}
          >
            <SupportDocs canSubmit={canSubmit} />
          </Tab>
        </Tabs>
        <hr />
        <div className="text-right">
          <LoaderButton
            disabled={!request.usersManual && !hasDocsToUpload}
            bsStyle="default"
            text="Save changes"
            isLoading={request.isLoading}
            onClick={this.onSaveClick}
            show={request.id > 0 && user.canUploadRequestDocs}
          />
          <LoaderButton
            disabled={false}
            bsStyle="info"
            text={<ContinueLabel />}
            isLoading={request.isLoading}
            onClick={() => this.props.submitWizardStep(wizard)}
            show={canSubmit}
          />
        </div>
      </div>
    );
  }
}

Documents.propTypes = {
  show: PropTypes.bool,
  canSave: PropTypes.bool,
  canSubmit: PropTypes.bool,
  editMode: PropTypes.bool
};

Documents.defaultProps = {
  show: true,
  canSave: false,
  canSubmit: false
};

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(
  mapStateToProps,
  {
    submitWizardStep,
    deleteUsersManual,
    startPreloader,
    finishPreloader,
    saveRequest
  }
)(Documents);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/Documents.js